export default (function (_ref, inject) {
    var app = _ref.app,
        redirect = _ref.redirect;

    app.router.beforeEach(function (to, from, next) {
        if (typeof to.params.lang != 'undefined') {
            if (['en', 'ar', 'tr', 'fr', 'ru', 'pt', 'ja'].indexOf(to.params.lang) == -1) {
                if (typeof global.websiteSettings.extra_info.default_language == 'undefined') {
                    redirect(301, '/en');
                } else {
                    redirect(301, '/' + global.websiteSettings.extra_info.default_language);
                }
            }
        }
        next();
    });
});


//////////////////
// WEBPACK FOOTER
// ./plugins/lang-check.js
// module id = ./plugins/lang-check.js
// module chunks = 54